import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'striphtml',
  standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): any {
    return value.replace(/<[^>]*>?/gm, ''); // replace tags
  }
}
